import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Label } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "./verifyotp.css";
import { toast } from "react-toastify";
import OtpInput from 'react-otp-input';
import ApiClient from "../../api-client";

function VerifyOtp() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {}; // Get email from location state
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [validationError, setValidationError] = useState("");
  const [remainingTime, setRemainingTime] = useState(300); // 5 minutes in seconds
  const [submitDisabled, setSubmitDisabled] = useState(false);

  useEffect(() => {
    // Start the timer countdown
    const interval = setInterval(() => {
      setRemainingTime(prevTime => prevTime - 1);
    }, 1000);

    // Clear interval and disable submit button when time is up
    if (remainingTime === 0) {
      clearInterval(interval);
      setSubmitDisabled(true);
    }

    return () => clearInterval(interval);
  }, [remainingTime]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6 || !/^\d+$/.test(otp)) {
      setErrors({ otp: "OTP must be a 6-digit number" });
      return;
    }
    setValidationError("");
    try {
      const response = await ApiClient.post("users/verifyotp",{ email, otp:Number(otp) });

      if (response.status === true) {
        toast.success(response.message ,{autoClose:3000})
        navigate("/reset-password", { state: { email } });
      } else {
        toast.error(response.message, { autoClose: 3000 });
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
    }
  };

  const handleOtpChange = (otp) => {
    // Check for non-numeric characters
    if (!/^\d+$/.test(otp)) {
      setValidationError("Please enter only numbers");
    } else {
      setValidationError("");
    }
    // Filter out non-numeric characters
    const filteredOtp = otp.replace(/\D/g, "");
    setOtp(filteredOtp);
  };

  const handleResendOtp = async () => {
    try {
      const response = await ApiClient.post("users/resendotp", { email });

      if (response.status === true) {
        toast.success(response.message, { autoClose: 3000 });
        setRemainingTime(300); // Reset the timer
        setSubmitDisabled(false); // Enable submit button
      } else {
        toast.error(response.message, { autoClose: 3000 });
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="mb-10">Welcome</h2>
        <div className="login-logo">Admin</div>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label className="label-text" for="otp">
              OTP
            </Label>
            <OtpInput
                  value={otp}
                  onChange={handleOtpChange} // Use the handler
                  numInputs={6}
                  separator={<span>-</span>}
                  // Provide a renderInput function to render each input field
                  renderInput={(inputProps, index) => (
                    <input
                      value={inputProps.value}
                      {...inputProps}
                      className="form-control otp-input"
                      autoFocus={index === 0 ? true : undefined}
                      style={{
                        // border: "none",
                        borderBottom: "1px solid gray",
                        // width: "0.1rem", // Adjust width as needed
                        margin: "0 0.1rem",
                        fontSize: "1.5rem",
                        textAlign: "center",
                        display: "inline-block", // Ensures the input is treated as a block element
                        verticalAlign: "middle", // Vertically aligns the input within its container
                      }}
                    />
                  )}
                />
                {validationError && (
                  <p  className="error-message">{validationError}</p>
                )}

          </FormGroup>
        
          <Button type="submit" className="login-button"  disabled={!otp || validationError || submitDisabled}>
            Submit
          </Button>
          <p className="signup-link" onClick={handleResendOtp}>
            Resend OTP ({Math.floor(remainingTime / 60)}:{remainingTime % 60})
          </p>
        </Form>
      </div>
    </div>
  );
}

export default VerifyOtp;